import { render, staticRenderFns } from "./extensionlinkdialog.vue?vue&type=template&id=365e99aa&scoped=true"
import script from "./extensionlinkdialog.vue?vue&type=script&lang=js"
export * from "./extensionlinkdialog.vue?vue&type=script&lang=js"
import style0 from "./extensionlinkdialog.vue?vue&type=style&index=0&id=365e99aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e99aa",
  null
  
)

export default component.exports